'use client';

import { c as _c } from "react/compiler-runtime";
import { Radio } from '@common/components';
import { cn } from '@core/utils';
import { useRef } from 'react';
import type { GiftProductDetail } from '@/api/getGiftProductDetail';
import { calculateRequiredDonationAmount, MAX_GIFT_ORDER_QUANTITY } from '@/app/donation/_utils/giftOrder';
import { QuantityStepper } from '@/components/molecule/QuantityStepper';
import { formatOptionLabel } from '../../../../_utils/formatOptionLabel';
import { useGiftOption } from '../../_context/GiftOptionContext';
import { GiftDonateButton } from '../GiftDonateButton';
interface PrefillFormProps {
  productData?: GiftProductDetail;
  productNumber: string;
  className?: string;
}
export const PrefillForm = t0 => {
  const $ = _c(62);
  const {
    productData,
    productNumber,
    className
  } = t0;
  const {
    selectedOptions,
    handleOptionSelect,
    getSelectedOptions,
    quantity,
    handleQuantityChange,
    resetSelection
  } = useGiftOption();
  let baseDonationAmount;
  let currentPrice;
  let hasOptions;
  let isSingleOptionGroup;
  let optionGroups;
  let quantityLabel;
  let t1;
  let totalPrice;
  if ($[0] !== productData?.currentPrice || $[1] !== productData?.optionGroupInfoList || $[2] !== quantity || $[3] !== selectedOptions) {
    optionGroups = productData?.optionGroupInfoList ?? [];
    hasOptions = optionGroups.length > 0;
    currentPrice = productData?.currentPrice ?? 0;
    const requiredOptionGroups = optionGroups.filter(_temp);
    const isAllRequiredOptionsSelected = hasOptions && requiredOptionGroups.every(g_0 => selectedOptions.has(g_0.optionGroupId ?? 0));
    let t2;
    bb0: {
      if (!isAllRequiredOptionsSelected) {
        t2 = null;
        break bb0;
      }
      const optionNames = [];
      optionGroups.forEach(group => {
        const selected = selectedOptions.get(group.optionGroupId ?? 0);
        if (selected) {
          const optionItem = group.optionItemInfoList?.find(item => item.optionItemId === selected.optionItemId);
          if (optionItem?.itemName) {
            optionNames.push(optionItem.itemName);
          }
        }
      });
      t2 = optionNames.join(" ");
    }
    const selectedOptionText = t2;
    quantityLabel = hasOptions ? selectedOptionText : "\uC218\uB7C9";
    baseDonationAmount = calculateRequiredDonationAmount(currentPrice);
    let t3;
    if ($[12] !== selectedOptions) {
      t3 = Array.from(selectedOptions.values()).reduce(_temp2, 0);
      $[12] = selectedOptions;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    const totalExtraProductPrice = t3;
    totalPrice = calculateRequiredDonationAmount(currentPrice + totalExtraProductPrice) * quantity;
    isSingleOptionGroup = optionGroups.length === 1;
    t1 = optionGroups.filter(_temp3).map(_temp4);
    $[0] = productData?.currentPrice;
    $[1] = productData?.optionGroupInfoList;
    $[2] = quantity;
    $[3] = selectedOptions;
    $[4] = baseDonationAmount;
    $[5] = currentPrice;
    $[6] = hasOptions;
    $[7] = isSingleOptionGroup;
    $[8] = optionGroups;
    $[9] = quantityLabel;
    $[10] = t1;
    $[11] = totalPrice;
  } else {
    baseDonationAmount = $[4];
    currentPrice = $[5];
    hasOptions = $[6];
    isSingleOptionGroup = $[7];
    optionGroups = $[8];
    quantityLabel = $[9];
    t1 = $[10];
    totalPrice = $[11];
  }
  const requiredOptionGroupIds = t1;
  const optionSectionRef = useRef(null);
  let t2;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      optionSectionRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    };
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  const scrollToOptionSection = t2;
  if (!productData) {
    return null;
  }
  let t3;
  if ($[15] !== className) {
    t3 = cn("flex flex-col gap-36", className);
    $[15] = className;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== baseDonationAmount || $[18] !== currentPrice || $[19] !== handleOptionSelect || $[20] !== isSingleOptionGroup || $[21] !== optionGroups || $[22] !== selectedOptions) {
    let t5;
    if ($[24] !== baseDonationAmount || $[25] !== currentPrice || $[26] !== handleOptionSelect || $[27] !== isSingleOptionGroup || $[28] !== selectedOptions) {
      t5 = optionGroup => {
        const groupId = optionGroup.optionGroupId ?? 0;
        const selectedInGroup = selectedOptions.get(groupId);
        return <div key={groupId} className="flex flex-col">{optionGroup.optionGroupName && <p className="flex items-center gap-4 pb-8 pt-16 font-500 text-Gray-600 typo-body4">{isSingleOptionGroup ? "\uB2F5\uB840\uD488 \uC635\uC158 \uC120\uD0DD" : optionGroup.optionGroupName}{optionGroup.requiredYN && <span className="font-600 text-R-500">*</span>}</p>}<Radio.Group value={selectedInGroup?.optionItemId} onChange={selectedItemId => {
            const selectedItem = optionGroup.optionItemInfoList?.find(item_0 => item_0.optionItemId === selectedItemId);
            if (selectedItem && !selectedItem.displaySoldOutYN) {
              handleOptionSelect(groupId, selectedItemId as number, selectedItem.extraProductPrice ?? 0);
            }
          }} theme="black" className="flex flex-col">{optionGroup.optionItemInfoList?.map(optionItem_0 => {
              const itemId = optionItem_0.optionItemId ?? 0;
              const isSoldOut = optionItem_0.displaySoldOutYN ?? false;
              const displayLabel = formatOptionLabel(optionItem_0.itemName ?? "", {
                isSoldOut,
                extraDonationAmount: calculateRequiredDonationAmount(currentPrice + (optionItem_0.extraProductPrice ?? 0)) - baseDonationAmount
              });
              return <div key={itemId} className="flex items-center gap-16 border-b border-Gray-200 py-16"><button type="button" onClick={() => {
                  if (!isSoldOut) {
                    handleOptionSelect(groupId, itemId, optionItem_0.extraProductPrice ?? 0);
                  }
                }} disabled={isSoldOut} className={cn("flex flex-1 items-center", isSoldOut && "cursor-not-allowed opacity-50")}><Radio.Item value={itemId} className="pointer-events-none"><span className="flex-1 text-left font-400 text-Gray-700 typo-body4">{displayLabel}</span></Radio.Item></button></div>;
            })}</Radio.Group></div>;
      };
      $[24] = baseDonationAmount;
      $[25] = currentPrice;
      $[26] = handleOptionSelect;
      $[27] = isSingleOptionGroup;
      $[28] = selectedOptions;
      $[29] = t5;
    } else {
      t5 = $[29];
    }
    t4 = optionGroups.map(t5);
    $[17] = baseDonationAmount;
    $[18] = currentPrice;
    $[19] = handleOptionSelect;
    $[20] = isSingleOptionGroup;
    $[21] = optionGroups;
    $[22] = selectedOptions;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[30] !== handleQuantityChange || $[31] !== hasOptions || $[32] !== quantity || $[33] !== quantityLabel || $[34] !== resetSelection) {
    t5 = quantityLabel && <div className="rounded-small bg-Gray-25 p-12"><div className="flex w-full items-center justify-between"><span className="font-400 text-Gray-800 typo-caption1">{quantityLabel}</span><QuantityStepper count={quantity} max={MAX_GIFT_ORDER_QUANTITY} onCountChange={handleQuantityChange} onDelete={hasOptions ? resetSelection : undefined} /></div></div>;
    $[30] = handleQuantityChange;
    $[31] = hasOptions;
    $[32] = quantity;
    $[33] = quantityLabel;
    $[34] = resetSelection;
    $[35] = t5;
  } else {
    t5 = $[35];
  }
  let t6;
  if ($[36] !== t4 || $[37] !== t5) {
    t6 = <div ref={optionSectionRef} data-gift-option-section={true} className="flex flex-col gap-28">{t4}{t5}</div>;
    $[36] = t4;
    $[37] = t5;
    $[38] = t6;
  } else {
    t6 = $[38];
  }
  let t7;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="font-600 text-Gray-900 typo-h6">기부금액</span>;
    $[39] = t7;
  } else {
    t7 = $[39];
  }
  let t8;
  if ($[40] !== totalPrice) {
    t8 = totalPrice.toLocaleString("ko-KR");
    $[40] = totalPrice;
    $[41] = t8;
  } else {
    t8 = $[41];
  }
  let t9;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span>원</span>;
    $[42] = t9;
  } else {
    t9 = $[42];
  }
  let t10;
  if ($[43] !== t8) {
    t10 = <div className="flex items-center justify-between">{t7}<span className="flex items-center gap-2 font-800 text-Gray-900 typo-h4">{t8}{t9}</span></div>;
    $[43] = t8;
    $[44] = t10;
  } else {
    t10 = $[44];
  }
  let t11;
  if ($[45] !== getSelectedOptions || $[46] !== optionGroups) {
    t11 = getSelectedOptions(optionGroups);
    $[45] = getSelectedOptions;
    $[46] = optionGroups;
    $[47] = t11;
  } else {
    t11 = $[47];
  }
  let t12;
  if ($[48] !== hasOptions || $[49] !== productData || $[50] !== productNumber || $[51] !== quantity || $[52] !== requiredOptionGroupIds || $[53] !== t11) {
    t12 = <GiftDonateButton productInfo={productData} productNumber={productNumber} selectedOptions={t11} hasOptions={hasOptions} requiredOptionGroupIds={requiredOptionGroupIds} theme="primary-fill" onOptionNotSelected={scrollToOptionSection} quantity={quantity} />;
    $[48] = hasOptions;
    $[49] = productData;
    $[50] = productNumber;
    $[51] = quantity;
    $[52] = requiredOptionGroupIds;
    $[53] = t11;
    $[54] = t12;
  } else {
    t12 = $[54];
  }
  let t13;
  if ($[55] !== t10 || $[56] !== t12) {
    t13 = <div className="flex flex-col gap-24 mobile:hidden tablet:hidden">{t10}{t12}</div>;
    $[55] = t10;
    $[56] = t12;
    $[57] = t13;
  } else {
    t13 = $[57];
  }
  let t14;
  if ($[58] !== t13 || $[59] !== t3 || $[60] !== t6) {
    t14 = <form onSubmit={_temp5} className={t3}>{t6}{t13}</form>;
    $[58] = t13;
    $[59] = t3;
    $[60] = t6;
    $[61] = t14;
  } else {
    t14 = $[61];
  }
  return t14;
};
function _temp(g) {
  return g.requiredYN;
}
function _temp2(total, option) {
  return total + option.extraProductPrice;
}
function _temp3(g_1) {
  return g_1.requiredYN;
}
function _temp4(g_2) {
  return g_2.optionGroupId;
}
function _temp5(e) {
  e.preventDefault();
}